import React from 'react'
import RmxFooterImage from "../../assets/images/footerIcon.png";
import RmxFooter from "../../assets/images/footer.png";
import { Row, Col } from "antd";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import SurfaceLogo from '../../assets/images/trkr-logo.png'

export default function rmxFooter() {
    return (
        <Row>
        <Col span={24}>
          <Row>
            <Col
              xl={24}
              className="rmx-containers"
              style={{
                fontWeight: "500",
                backgroundImage: `url(${RmxFooter})`,
              }}
            >
              <Row
                className="rmx-footer-row"
                justify="space-between"
                align="middle"
              >
                <Col xl={6}>
                  <img
                    src={RmxFooterImage}
                    className="rmx-footer-image"
                    height={250}
                    width={250}
                  />
                </Col>
                <Col xl={8}>
                  <Row>
                    <Col span={24}>
                      <h3 style={{ fontWeight: "750" }}>MAIN-FRAME</h3>
                    </Col>
                    <Col span={24}>
                      <span>
                        888 Prospect Street, Suite 200, La Jolla, CA 92037
                      </span>
                    </Col>
                    <Col span={24}>
                      <span>info@main-frame.com </span>
                    </Col>
                    <Col span={24}>
                      <span>+1 619 880 0265</span>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6} style={{ paddingBottom: "50px" }}>
                  {/* <Row
                    justify="start"
                    align="bottom"
                    className="rmx-footer-icons"
                  >
                    <Col xl={4} className="pointer-cursor">
                      <AiOutlineTwitter color="black" size="25" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaFacebookF color="black" size="25" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaInstagram color="black" size="25" />
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              <Col
                className="rmx-copyright"
                style={{ color: "black", fontWeight: "600" }}
              >
                <span>
                  © {new Date().getFullYear()} Main Frame . All Rights Reserved.
                </span>
              </Col>
            </Col>
          </Row>
        </Col>
        </Row>
    )
}
